import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppPrepaidAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Prepaid"
		placeholder="Any option"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/payment_method`}
		{...props}
	/>
}
